import script from "./BoardsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardsView.vue?vue&type=script&setup=true&lang=js"

import "./BoardsView.vue?vue&type=style&index=0&id=5638350f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5638350f"]])

export default __exports__